import "./AddOrderButton.less";
import React from "react";
import { Menu, Dropdown, Button, Popover } from "antd";
import { CaretUpOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ShopDTO from "@/dto/shop/ShopDTO";
import useAuthorityCheck from "@/hooks/useAuthorityCheck";
import Authority from "@/enum/Authority";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import ShopType from "@/enum/ShopType";
import { MenuDivider, MenuItem, MenuItemGroup, SubMenu, buildMenuItems } from "@/utils/antdItems";

interface AddOrderButtonProps {
    shop: ShopDTO;
}

/**
 * 添加订单按钮
 */
const AddOrderButton: React.FC<AddOrderButtonProps> = function (props) {
    const { shop } = props;

    const globalStore = useGlobalStore();
    const search = `shopId=${shop.id}`;

    const { hasAuthority, openAuthorityModal } = useAuthorityCheck(Authority.ROLE_ORDER_IMPORT);

    const ownerShop = globalStore.shopMapping.get(shop.ownerShopId);

    const shopSetting = globalStore.shopSettingMapping.get(shop.id);

    // 手工店铺限制
    // 如果没有店铺到期时间并且没有所属平台店铺，则限制添加订单
    if (shop.type === ShopType.MANUAL && !ownerShop && !shopSetting?.subscriptionEndTime) {
        return null;
    }

    const overlay = (
        <Menu items={buildMenuItems(<>
            <MenuItem key="input">
                <Link to={{ pathname: "/manualOrder/add", search }} onClick={handleAuthorityCheck}>
                    手工录入订单
                </Link>
            </MenuItem>

            <MenuItem key="batch">
                <Popover
                    content={
                        <span>
                            导入订单给代发商发货，不如试试供货商发货易-分销版本，直接获取代理商订单打印发货。
                            <a href="https://qw15p3s8hv.feishu.cn/wiki/wikcnfYxMjpdwoNLnMIKHDwUqTd" target="_blank">
                                详情查看这里
                            </a>
                        </span>
                    }
                    styles={{ root: { width: "400px" } }}
                    placement="left"
                >
                    <Link to={{ pathname: "/manualOrder/import", search }} onClick={handleAuthorityCheck}>
                        批量导入订单
                    </Link>
                </Popover>
            </MenuItem>

            {!globalStore.companyRoleStore.isPureSupplier ? (
                <MenuItem key="importPlatformOrderOriginalId">
                    <Link
                        to={{ pathname: "/manualOrder/importPlatformOrderOriginalId", search }}
                        onClick={handleAuthorityCheck}
                    >
                        批量导入平台订单号
                    </Link>
                </MenuItem>
            ) : null}
        </>)} />
    );

    function handleAuthorityCheck(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        if (!hasAuthority) {
            e.preventDefault();

            openAuthorityModal();
        }
    }

    return (
        <Dropdown menu={{ items: [] }} popupRender={() => overlay} placement="topLeft" trigger={["click"]} className="mr3">
            <Button type="primary" className="ec-add-order-button">
                添加订单 <CaretUpOutlined />
            </Button>
        </Dropdown>
    );
};

export default observer(AddOrderButton);
